export enum GameRoles {
  TOP = "TOP",
  JUNGLE = "JUNGLE",
  MIDDLE = "MIDDLE",
  BOTTOM = "BOTTOM",
  SUPPORT = "SUPPORT",
  ALL = "ALL"
}

export enum GameSide {
  BLUE = 'BLUE',
  RED = 'RED',
}